import { Injectable } from "@angular/core";

const AUTH_TOKEN = "auth-token";
const REFRESH_TOKEN = "refresh-token";
const USER_KEY = "user-key";

@Injectable({
	providedIn: "root",
})
export class TokenStorageService {
	constructor() {}

	signOut(): void {
		window.sessionStorage.clear();
	}

	public saveToken(token: string): void {
		window.sessionStorage.removeItem(AUTH_TOKEN);
		window.sessionStorage.setItem(AUTH_TOKEN, token);
	}

	public saveRefreshToken(token: string): void {
		window.sessionStorage.removeItem(REFRESH_TOKEN);
		window.sessionStorage.setItem(REFRESH_TOKEN, token);
	}

	public getToken(): string | null {
		return window.sessionStorage.getItem(AUTH_TOKEN) || "";
	}

	public getRefreshToken(): string | null {
		return window.sessionStorage.getItem(REFRESH_TOKEN) || "";
	}

	public saveUser(user: any): void {
		window.sessionStorage.removeItem(USER_KEY);
		window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
	}

	public getUser(): any {
		const user = window.sessionStorage.getItem(USER_KEY);
		if (user) {
			return JSON.parse(user);
		}

		return {};
	}
}
